import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash-es';

export interface SimpleConfirmModalData {
  hideCancelButton?: boolean;
  hideCloseButton?: boolean;
  hideOkButton?: boolean;
  hideTitle?: boolean;
  onAcceptModal?: () => void;
  onCancelModal?: () => void;
  text?: string;
  title?: string;
  additionalButtons?: { name: string; onClick?: () => void }[];
}

@Component({
  selector: 'hk-simple-confirm-modal',
  template: `
    <hk-base-modal
      [hideCloseButton]="data.hideCloseButton ?? false"
      [hideCancelButton]="data.hideCancelButton ?? false"
      [hideApplyButton]="data.hideOkButton ?? false"
      [title]="data.title"
      (cancel)="this.data.onCancelModal?.()"
      (apply)="this.data.onAcceptModal?.()"
    >
      <div class="!my-auto" [innerHTML]="data.text"></div>
      <ng-container additionalButtons>
        <button *ngFor="let button of data.additionalButtons!" (click)="button.onClick?.()" hk-button-stroked class="mr-2">
          {{ button.name }}
        </button>
      </ng-container>
    </hk-base-modal>
  `,
  styles: [],
})
export class SimpleConfirmModalComponent {
  constructor(
    public dialogReference: MatDialogRef<SimpleConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleConfirmModalData,
    private translate: TranslateService,
  ) {
    const defaultData: SimpleConfirmModalData = {
      title: this.translate.instant('common.confirm'),
      text: this.translate.instant('crudTable.areYouSure'),
      onCancelModal: () => {
        // not needed
      },
      onAcceptModal: () => {
        // not needed
      },
      hideCancelButton: false,
      hideTitle: false,
      hideOkButton: false,
      hideCloseButton: false,
      additionalButtons: [],
    };

    this.data = _.assign(defaultData, data);
  }
}
